import React, { useState } from 'react';
import { t } from '../../locales/translate';
import { Button } from '../Button/Button';
import { FormFileUpload } from '../Form/FileUpload/FormFileUpload';
import { useTask } from '../../model/data';
import { useModal } from '../Modal/PresentedModal';

interface Props {
  type?: 'text/csv';
  title?: string;
  overrideText?: {
    cancel?: string;
    submit?: string;
  };
  submit?: (file: File) => Promise<unknown>;
  onUploadComplete?: () => void;
}

// @TODO: reuse modal in Bank Statement Import #1812
export function FileUploadModal({ type, overrideText, submit, onUploadComplete, title }: Props): JSX.Element {
  const [file, setFile] = useState<File | undefined | null>(null);
  const exportTask = useTask({ handleError: true });
  const { close, Modal, open } = useModal();

  return (
    <Modal
      open={open}
      title={title}
      footer={
        <>
          <Button
            title={overrideText?.cancel || t.actions.cancel('')}
            onClick={() => {
              close();
            }}
          />
          <Button
            type="primary"
            title={overrideText?.submit || t.actions.upload('')}
            onClick={() => {
              if (submit && file) {
                exportTask.run(
                  submit?.(file).then(() => {
                    onUploadComplete?.();
                    close();
                  })
                );
              }
            }}
            disabled={!file}
            loading={exportTask.loading}
          />
        </>
      }
    >
      <FormFileUpload required accept={type} value={file} onChange={(file) => setFile(file)} />
    </Modal>
  );
}
